import React, { createContext, useReducer, useEffect } from "react";

interface State {
  darkMode: boolean;
}

interface Action {
  type: "LIGHTMODE" | "DARKMODE";
}

interface ThemeProviderProps {
  children: React.ReactNode;
}

// Función para obtener el tema guardado en localStorage
const getInitialTheme = (): State => {
  const savedTheme = localStorage.getItem("theme");
  // Si no hay tema guardado, retornamos LIGHTMODE (darkMode: false)
  if (!savedTheme) {
    return { darkMode: false };
  }
  return { darkMode: savedTheme === "dark" };
};

const initialState = getInitialTheme();

export const ThemeContext = createContext<{
  state: State;
  dispatch: React.Dispatch<Action>;
}>({
  state: initialState,
  dispatch: () => null,
});


const themeReducer = (state: State, action: Action): State => {
  switch (action.type) {
    case "LIGHTMODE":
      return { darkMode: false };
    case "DARKMODE":
      return { darkMode: true };
    default:
      return state;
  }
};

export function ThemeProvider(props: ThemeProviderProps) {
  const [state, dispatch] = useReducer(themeReducer, initialState);

  // Guardar el tema en localStorage cada vez que cambie
  useEffect(() => {
    const theme = state.darkMode ? "dark" : "light";
    localStorage.setItem("theme", theme);
    console.log("ThemeProvider state:", state, "- Theme saved:", theme);
  }, [state]);

  return (
    <ThemeContext.Provider
      value={{ state: state ?? initialState, dispatch: dispatch }}
    >
      {props.children}
    </ThemeContext.Provider>
  );
}
